import PageCard from 'features/shared/components/card/PageCard';
import { Currency } from 'features/shared/enums/currency';
import React from 'react';
import InvoiceRecapitulationDTO from '../dtos/InvoiceRecapitulationDTO';
import { InvoiceRecapitulationType } from '../enums/invoiceRecapitulationType';
import { InvoiceType } from '../enums/invoiceType';
import InvoiceRecapitulationItem from './InvoiceRecapitulationItem';
import InvoiceRecapitulationTotalItem from './InvoiceRecapitulationTotalItem';
import styles from './invoicerecapitulationcard.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  recapitulation: InvoiceRecapitulationDTO[];
  currency: Currency;
  type: InvoiceType;
}

const InvoiceRecapitulationCard = ({ recapitulation, currency, type }: Props) => {
  // translations
  const tLabels = useTranslation("invoice\\invoice").t;

  // sub-renders
  const renderRecapitulationItems = () => {
    let result:JSX.Element[] = [];

    for (let index = 0; index < recapitulation.length; index++) {
      const item = recapitulation[index];
      
      if (item.invoiceRecapitulationType === InvoiceRecapitulationType.Total) {
        result.push(<InvoiceRecapitulationTotalItem recapitulationItem={item} currency={currency} invoiceType={type} key={index} />);
      } else {
        result.push(<InvoiceRecapitulationItem  recapitulationItem={item} currency={currency} key={index} />);
      }
    }

    return result;
  }

  const renderRecapitulationHeader = () => {
    if (type === InvoiceType.Invoice) {
      return (
        <div className="d-flex justify-content-end px-sm-2 font-weight-bold text-muted mb-1">
          <span className="order-1 order-sm-0 mr-sm-4">
            <span className="d-sm-none">/</span>
            {tLabels("invoiceRecapitulationCard.noTax")}
          </span>
          <span className={styles.total}>
            {tLabels("invoiceRecapitulationCard.total")}
          </span>
        </div>
      );
    }
  }

  // render
  return (
    <PageCard title={tLabels("invoiceRecapitulationCard.recapitulation")}>
      {renderRecapitulationHeader()}
      {renderRecapitulationItems()}
    </PageCard>
  )
}

export default InvoiceRecapitulationCard;
